import React, {useEffect, useState} from "react";
import Dollars from "./Dollars";

export default function SummaryTable({ rows, columns, onRowClick, selectedRow, collapseAfter }) {
  collapseAfter ||= rows.length;

  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    setExpanded(false)
  }, [rows]);

  function rowClass(row) {
    const classes = []

    if (row?.id === selectedRow?.id || row === selectedRow) {
      classes.push("table-info")
    }
    return classes.join(" ")
  }

  let tableClass = "table table-sm table-striped"
  if (onRowClick) {
    tableClass += " table-hover"
  }

  let rowsToShow = rows
  if (!expanded) {
    rowsToShow = rows.slice(0, collapseAfter)
  }
  return (
    <table className={tableClass}>
      <thead>
        <tr>
          {columns.map((column, index) => (
            <Header key={index} column={column} />
          ))}
        </tr>
      </thead>
      <tbody>
        {rowsToShow.map((row, index) => {
          return (<tr onClick={() => onRowClick && onRowClick(row)}
            className={rowClass(row)}
            key={index}>
            {columns.map((column, index) => (
              <Cell key={index} column={column} row={row} />
            ))}
          </tr>)
        })}
        {rows.length > collapseAfter && !expanded && <tr>
          <td>
            <button className="btn btn-link" onClick={() => setExpanded(!expanded)}>
              {`${rows.length - collapseAfter} more`}
            </button>
          </td>
          {columns.slice(1).map((column, index) => (
            <SummaryCell key={index} column={column} rows={rows.slice(collapseAfter)} />
          ))}
        </tr>}
      </tbody>
    </table>
  )
}

function cellClass(column) {
  if (["currency", "percent", "number"].includes(column.type)) {
    return "text-end"
  }
  return ""
}

function Header({ column }) {
  const thClass = `${cellClass(column)} text-no-wrap`
  return <th className={thClass}>{column.title}</th>
}

function Cell({ column, row }) {
  let value
  // if value is a function, invoke it with the column
  if (typeof column.value === "function") {
    value = column.value(row)
  }
  // othwerwise, assum valus is a string that is the key to the row
  else {
    value = row[column.value]
  }
  let renderedValue
  if (column.type === "currency") {
    // convert to currency
    const number = parseFloat(value)
    renderedValue = <Dollars amount={number} />
  }
  if (column.type === "percent") {
    // convert to percent
    const number = parseFloat(value)
    renderedValue = number.toLocaleString(undefined, { style: "percent" })
  }
  if (column.render) {
    renderedValue = column.render(row)
  }
  return <td className={cellClass(column)}>
    {renderedValue || value}
  </td>
}

function SummaryCell({ column, rows }) {
  const value = rows.reduce((sum, row) => sum + row[column.value], 0)
  return <Cell column={column} row={{ [column.value]: value }} />
}
